const translations = {
  es: {
    titulo: "Iniciar Sesión como Paciente",
    telefono: "Número de teléfono",
    correo: "Correo electrónico",
    contrasena: "Contraseña",
    loginWhatsapp: "Entrar con WhatsApp",
    loginGmail: "Entrar con Gmail",
    o: "o",
  },
  en: {
    titulo: "Patient Login",
    telefono: "Phone number",
    correo: "Email",
    contrasena: "Password",
    loginWhatsapp: "Login with WhatsApp",
    loginGmail: "Login with Gmail",
    o: "or",
  },
};
export default translations;